import { render } from "./SwitchCheckbox.vue?vue&type=template&id=8a63d8c6&scoped=true"
import script from "./SwitchCheckbox.vue?vue&type=script&lang=js"
export * from "./SwitchCheckbox.vue?vue&type=script&lang=js"

import "./SwitchCheckbox.vue?vue&type=style&index=0&id=8a63d8c6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a63d8c6"]])

export default __exports__